import React, { useMemo } from 'react'
import { Stack, Typography, Tooltip, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { StepGroupProps } from '../../../types'
import { ProcessCard } from './ProcessCard'
import { STEPS_WITHOUT_TOOLTIP } from '../../../constants'
import { areAllProcessesInStepCompleted } from '../../../helpers'

export const StepGroup: React.FC<StepGroupProps> = ({ stepName, processes, isLast }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const allCompleted = useMemo(() => areAllProcessesInStepCompleted(processes), [processes])
  const shouldShowTooltip = !STEPS_WITHOUT_TOOLTIP.includes(stepName) && !allCompleted

  return (
    <Stack 
      sx={{ 
        flex: 1,
        minWidth: 0,
        borderRight: !isLast ? `1px solid ${theme.palette.grey[200]}` : 'none'
      }}
    >
      <Stack 
        direction="row" 
        alignItems="center" 
        justifyContent="center" 
        gap={1}
        sx={{
          padding: 2,
          borderBottom: `1px solid ${theme.palette.grey[200]}`,
          minHeight: 56,
          width: '100%'
        }}
      >
        <Typography 
          component="span" 
          sx={{ 
            fontSize: 14, 
            fontWeight: 600,
            color: theme.palette.text.primary,
            textAlign: 'center'
          }}
        >
          {t(`projects.process.step.${stepName}`)}
        </Typography>
        {shouldShowTooltip && (
          <Tooltip 
            title={t(`projects.process.alert.${stepName}`)} 
            placement="top" 
            arrow
          >
            <i 
              className="fa-regular fa-circle-info" 
              style={{ 
                color: '#989898',
                fontSize: 14
              }} 
            />
          </Tooltip>
        )}
      </Stack>

      <Stack sx={{ flex: 1, width: '100%' }}>
        {processes.map((process, index) => (
          <ProcessCard 
            key={process.id} 
            process={process} 
            isLast={index === processes.length - 1}
          />
        ))}
      </Stack>
    </Stack>
  )
}